import { z } from 'zod';

export const NotificationPreferencesModalSchema = z.object({
  availabilityNotification: z.boolean().nullable(),
  benchNotification: z.boolean().nullable(),
  marketingCommunications: z.boolean().nullable(),
});

export type NotificationPreferencesModalTypes = z.infer<
  typeof NotificationPreferencesModalSchema
>;
